function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99967 0.333252C10.6757 0.333252 13.6663 3.32396 13.6663 6.99996C13.6663 10.676 10.6757 13.6666 6.99967 13.6666C3.32367 13.6666 0.333008 10.676 0.333008 6.99996C0.333008 3.32396 3.32367 0.333252 6.99967 0.333252ZM6.99967 1.33325C3.87503 1.33325 1.33301 3.87536 1.33301 6.99996C1.33301 10.1246 3.87503 12.6666 6.99967 12.6666C10.1243 12.6666 12.6663 10.1246 12.6663 6.99996C12.6663 3.87536 10.1243 1.33325 6.99967 1.33325ZM6.99967 5.66659C7.36785 5.66659 7.66634 5.92776 7.66634 6.24992V9.74992C7.66634 10.0721 7.36785 10.3333 6.99967 10.3333C6.6315 10.3333 6.33301 10.0721 6.33301 9.74992V6.24992C6.33301 5.92776 6.6315 5.66659 6.99967 5.66659ZM6.99967 3.66659C7.36728 3.66659 7.66634 3.96579 7.66634 4.33355C7.66634 4.70099 7.36728 4.99992 6.99967 4.99992C6.63207 4.99992 6.33301 4.70099 6.33301 4.33355C6.33301 3.96579 6.63207 3.66659 6.99967 3.66659Z",
  fill: "#FAF8F7"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.bcfef013.svg";
export { ForwardRef as ReactComponent };